// Cinematic CV data for Utkarsh Bokadia
// All image fields are placeholders — drop in URLs anytime to bring sections to life.

// User-provided photographs
export const PHOTOS = {
  jitoRacquetCup: "/photos/jito-racquet-cup.jpg",
  pickleballTrophy: "/photos/pickleball-trophy.jpg",
  yiSpeaker: "/photos/yi-speaker.jpg",
  yiBag: "/photos/yi-roundtable.jpg",
  newPortrait: "/photos/portrait.png",
  worldMap: "/photos/world-map.png",
  jaloreCity: "/photos/jalore-city.png",
  pavilion: "/photos/pavilion-reception.jpg",
  horseRiding: "/photos/horse-riding.png",
  oneWealth: "/photos/onewealth-event.png",
  teamSports: "/photos/marathon-team.png",
  satyapurOlympiad: "/photos/satyapur-olympiad.png",
  pickleballRunnerUp: "/photos/pickleball-runnerup.png",
  utsDiploma: "/photos/uts-diploma.png",
  ramCertificate: "/photos/ram2024-certificate.png",
  horseJumping1: "/photos/show-jumping-midair.jpg",
  horseJumping2: "/photos/show-jumping-pinto.jpg",
};

export const PROFILE = {
  name: "Utkarsh Bokadia",
  initials: "UB",
  city: "Ahmedabad, India",
  titles: [
    "Entrepreneur",
    "Investor",
    "Wealth Management Enthusiast",
    "Business Strategist",
  ],
  shortBio:
    "Builder of businesses, allocator of capital, student of markets. Drawn to compounding excellence in companies, people, and ideas.",
  email: "utkarshbokadia@gmail.com",
  phone: "+91 ",
  linkedin: "https://www.linkedin.com/in/utkarsh-bokadia-5b2412289",
  github: "",
  portrait: PHOTOS.newPortrait,
  resumeUrl: "#",
};

export const STORY_CHAPTERS = [
  {
    id: "origins",
    chapter: "Chapter I",
    title: "Roots in Rajasthan · Jalore, Sanchore",
    body:
      "A lineage rooted in the merchant towns of Rajasthan \u2014 Jalore and Sanchore \u2014 where enterprise, community, and family are inseparable. A childhood shaped by that heritage: watching markets, businesses, and ideas come alive in a family deeply grounded in commerce. Curiosity arrived early; ambition followed quietly.",
    keywords: ["Jalore", "Sanchore", "heritage", "commerce"],
    image: PHOTOS.jaloreCity,
  },
  {
    id: "boarding",
    chapter: "Chapter II",
    title: "The Discipline of Boarding School",
    body:
      "At Jain International Residential School, the days were governed by rigour and reverence \u2014 horse riding before sunrise, lessons in resilience, swimming, national competitions, and the quiet lesson that character is the longest compounding asset.",
    keywords: ["discipline", "leadership", "horsemanship"],
    image: "/photos/jirs-aerial.png",
  },
  {
    id: "international",
    chapter: "Chapter III",
    title: "A Global Lens",
    body:
      "IGCSE and the International Baccalaureate at Ahmedabad International School widened the world. Physics, research at the International Conference on Recent Trends in Applied Physics & Material Science, and a fascination with the underlying systems of how things work.",
    keywords: ["research", "IB", "systems thinking"],
    image: "/photos/ais-building.png",
  },
  {
    id: "business",
    chapter: "Chapter IV",
    title: "The Business of Building",
    body:
      "At GLS International Studies \u2014 a Diploma in Business in partnership with the University of Technology Sydney \u2014 finance, entrepreneurship, and global strategy became the vocabulary. Internships sharpened instinct into craft.",
    keywords: ["finance", "strategy", "entrepreneurship"],
    image: "/photos/gls-building.png",
  },
  {
    id: "future",
    chapter: "Chapter V",
    title: "What\u2019s Next",
    body:
      "Operating companies. An investment firm. A family office. Private equity, venture capital, artificial intelligence. A long, quiet patience for great businesses \u2014 and a lifetime spent compounding both capital and character.",
    keywords: ["PE/VC", "AI", "family office", "legacy"],
    image: "/photos/onewealth-event.png",
  },
];

export const TIMELINE = [
  { year: "2017", title: "Boarding Begins", place: "Jain International Residential School, Bengaluru", text: "Enters boarding school. Horse riding, swimming, athletics. Discipline becomes a daily practice.", tags: ["School", "Sports"] },
  { year: "2018", title: "Medals & Competitions", place: "National Sports Circuit", text: "Competes in inter-school and national sports events across swimming and equestrian disciplines.", tags: ["Achievement"] },
  { year: "2019", title: "Transition to International Curriculum", place: "Ahmedabad International School", text: "Begins IGCSE \u2014 physics, mathematics, business, languages. The analytical mind starts to sharpen.", tags: ["School"] },
  { year: "2020", title: "Research Presentation", place: "Int. Conference on Applied Physics & Material Science", text: "Presents original research alongside academic peers \u2014 first taste of rigour in inquiry.", tags: ["Research"] },
  { year: "2021", title: "IB Diploma Programme", place: "Ahmedabad International School", text: "Higher-level subjects in business, economics, and analysis. Extended Essay & Theory of Knowledge.", tags: ["School"] },
  { year: "2022", title: "First Internship", place: "Sportxcraft", text: "Steps into operations, vendor relationships, and the day-to-day of running a sports business.", tags: ["Work"] },
  { year: "2023", title: "Industry Exposure", place: "Marvel Impex \u00b7 Nimba Nature Cure", text: "International trade, exports, wellness operations \u2014 cross-industry exposure across mid-size enterprises.", tags: ["Work"] },
  { year: "2024", title: "Diploma in Business (UTS Pathway)", place: "GLS International Studies", text: "Finance, entrepreneurship, organisational behaviour, global business strategy.", tags: ["School"] },
  { year: "2024", title: "Infrastructure & Strategy", place: "Oswal Infrastructure Limited", text: "Strategic projects, financial modelling, real-world capital allocation.", tags: ["Work"] },
  { year: "2025", title: "Building for the Cause", place: "Hastkesar Panjrapole", text: "Designs and develops a responsive web platform \u2014 the first product launch.", tags: ["Project"] },
  { year: "2025", title: "Pickleball Tournament Champion", place: "Pickleball & Junoon \u2014 Season 1", text: "Wins the Pickleball & Junoon Season 1 tournament. A reminder that the discipline of sport never really leaves.", tags: ["Achievement"] },
  { year: "2026", title: "FYSE Ventures SRL \u00b7 Distributor", place: "Italy \u00b7 International", text: "Joins FYSE Ventures SRL as Distributor for premium cosmetics & personal-care \u2014 building international distribution and preparing for the Director seat.", tags: ["Work", "International"] },
  { year: "Now", title: "The Next Chapter", place: "", text: "Investments, AI ventures, and the slow, deliberate construction of a family office.", tags: ["Vision"] },
];

export const CAMPUS_IMAGES = {
  jirsGate: "/photos/jirs-gate.png",
  jirsAerial: "/photos/jirs-aerial.png",
  aisBuilding: "/photos/ais-building.png",
  glsBuilding: "/photos/gls-building.png",
  glsWall: "/photos/gls-wall.png",
};

export const EDUCATION = [
  {
    id: "jirs",
    name: "Jain International Residential School",
    location: "Bengaluru, Karnataka",
    span: "2017 \u2014 2019",
    program: "Middle & Senior School (Boarding)",
    description:
      "A residential immersion in discipline, sport, and self-reliance. Mornings on horseback, evenings in the pool, weekends at national competitions. Leadership wasn\u2019t taught \u2014 it was lived.",
    highlights: [
      "Equestrian \u2014 dressage, show jumping, national-level events",
      "Competitive swimming \u2014 inter-school medals",
      "Athletics, football, cricket, badminton, volleyball",
      "House leadership & residential responsibility",
    ],
    image: CAMPUS_IMAGES.jirsGate,
    gallery: [CAMPUS_IMAGES.jirsGate, CAMPUS_IMAGES.jirsAerial],
    accent: "#d4af37",
  },
  {
    id: "ais",
    name: "Ahmedabad International School",
    location: "Ahmedabad, Gujarat",
    span: "2019 \u2014 2023",
    program: "IGCSE \u00b7 International Baccalaureate (IBDP)",
    description:
      "A global curriculum that traded memorisation for inquiry. Physics, mathematics, business, languages \u2014 and a research presentation at the International Conference on Recent Trends in Applied Physics & Material Science that taught me how serious thought is built.",
    highlights: [
      "Research presented at international physics conference",
      "IBDP \u2014 Business, Economics, Mathematics, Physics",
      "Extended Essay & Theory of Knowledge",
      "Public speaking & MUN participation",
    ],
    image: CAMPUS_IMAGES.aisBuilding,
    gallery: [CAMPUS_IMAGES.aisBuilding],
    accent: "#3b82f6",
  },
  {
    id: "gls",
    name: "GLS University \u00b7 Gujarat Law Society",
    location: "Ahmedabad, Gujarat \u00b7 Pathway to UTS Sydney",
    span: "2024 \u2014 Present",
    program: "Diploma in Business \u00b7 University of Technology Sydney Pathway",
    description:
      "A serious, global, business-first programme. Entrepreneurship, finance, organisational behaviour, marketing, and the strategic frameworks behind enduring companies \u2014 anchored at GLS University with its founding spirit: Learn. Love. Serve.",
    highlights: [
      "University of Technology Sydney curriculum",
      "Finance, accounting, statistics, business strategy",
      "Entrepreneurship & organisational behaviour",
      "International business case studies",
    ],
    image: CAMPUS_IMAGES.glsWall,
    gallery: [CAMPUS_IMAGES.glsWall, CAMPUS_IMAGES.glsBuilding],
    accent: "#e6c769",
  },
];

export const SPORTS = [
  { name: "Horse Riding", level: "National", years: "2017 \u2014 2020", note: "Dressage & show jumping. Hours that built unflinching focus.", icon: "horse" },
  { name: "Pickleball", level: "Tournament Champion \u00b7 2025", years: "2024 \u2014 Present", note: "Pickleball & Junoon Season 1 \u2014 winner. Quick hands, quicker decisions.", icon: "trophy", image: PHOTOS.pickleballTrophy },
  { name: "Badminton", level: "JITO Racquet Cup", years: "2018 \u2014 Present", note: "JITO Racquet Cup participant. Reflex, footwork, and tempo.", icon: "activity", image: PHOTOS.jitoRacquetCup },
  { name: "Swimming", level: "Inter-school medals", years: "2017 \u2014 2022", note: "Freestyle & relay. Endurance and tempo control.", icon: "waves" },
  { name: "Athletics", level: "School representative", years: "2018 \u2014 2022", note: "Sprint and middle-distance.", icon: "flag" },
  { name: "Football", level: "School team", years: "2017 \u2014 2022", note: "Midfielder. Vision and tempo of play.", icon: "goal" },
  { name: "Cricket", level: "School team", years: "2018 \u2014 2022", note: "All-rounder. Patience under pressure.", icon: "target" },
  { name: "Volleyball", level: "School team", years: "2019 \u2014 2022", note: "Communication and coordination.", icon: "users" },
];

export const MOMENTS = [
  {
    id: "mHorse1",
    image: PHOTOS.horseJumping1,
    title: "Show Jumping — Mid-Air",
    caption: "Clean line over the red oxer · competition arena",
    tag: "Champion",
  },
  {
    id: "mHorse2",
    image: PHOTOS.horseJumping2,
    title: "Show Jumping — Pinto Mare",
    caption: "Tight bascule, perfect knees · evening light at the arena",
    tag: "Champion",
  },
  {
    id: "mPickRunner",
    image: PHOTOS.pickleballRunnerUp,
    title: "Pickleball Junoco — Runner-up",
    caption: "Runner-up team · Infinity Sports Pickleball",
    tag: "Tournament",
  },
  {
    id: "mYiSpeaker",
    image: PHOTOS.yiSpeaker,
    title: "Young Indians · 360° Conclave",
    caption: "Conversations with a featured speaker — Ahmedabad chapter",
    tag: "Networking",
  },
  {
    id: "mTeam",
    image: PHOTOS.teamSports,
    title: "Marathon · Team Celebration",
    caption: "Post-event celebration with teammates and organisers",
    tag: "Tournament",
  },
  {
    id: "mYiBag",
    image: PHOTOS.yiBag,
    title: "Young Indians · Industry Roundtable",
    caption: "Building relationships across business leaders",
    tag: "Networking",
  },
  {
    id: "mPavilion",
    image: PHOTOS.pavilion,
    title: "The Pavilion · Industry Reception",
    caption: "Networking with senior industry stalwarts",
    tag: "Networking",
  },
];

export const EXPERIENCES = [
  {
    id: "fyse",
    company: "FYSE Ventures SRL",
    role: "Distributor \u00b7 Incoming Director",
    span: "2026 \u2014 Present",
    location: "Italy \u00b7 International",
    website: "https://fyseitaly.com/",
    websiteDisplay: "fyseitaly.com",
    current: true,
    summary:
      "Currently associated with FYSE Ventures SRL as Distributor for the company\u2019s premium cosmetics and personal-care portfolio \u2014 expanding market presence, building strategic distribution networks, and developing international business opportunities. Preparing to step into the role of Director, contributing to business strategy, global expansion, and strengthening FYSE\u2019s position in international markets.",
    skills: [
      "International Business",
      "Distribution Strategy",
      "Premium Beauty / Personal Care",
      "Global Expansion",
      "Partnerships",
      "Brand Strategy",
    ],
    achievements: [
      "Building strategic distribution networks across markets",
      "Developing international business opportunities",
      "Preparing to take on the role of Director",
      "Shaping go-to-market for premium cosmetics & personal care",
    ],
  },
  {
    id: "sportxcraft",
    company: "Sportxcraft",
    role: "Operations & Business Intern",
    span: "2022",
    location: "Ahmedabad",
    summary:
      "First exposure to a working business. Vendor coordination, fulfilment, and the unglamorous mechanics that keep operations running.",
    skills: ["Operations", "Vendor Management", "Business Communication"],
    achievements: ["Streamlined fulfilment workflow", "Documented vendor SOPs"],
  },
  {
    id: "marvel",
    company: "Marvel Impex",
    role: "International Trade Intern",
    span: "2023",
    location: "Ahmedabad",
    summary:
      "Worked on import/export operations, logistics coordination, and exposure to international commerce.",
    skills: ["International Trade", "Logistics", "Documentation"],
    achievements: ["Supported export documentation", "Buyer correspondence"],
  },
  {
    id: "nimba",
    company: "Nimba Nature Cure & Holistic Healthcare Centre",
    role: "Business Operations Intern",
    span: "2023",
    location: "Mehsana, Gujarat",
    summary:
      "Hospitality operations, guest experience, and customer-facing service in a world-class wellness institution.",
    skills: ["Hospitality", "Guest Experience", "Operations"],
    achievements: ["Cross-functional exposure across F&B, wellness & front-office"],
  },
  {
    id: "oswal",
    company: "Oswal Infrastructure Limited",
    role: "Strategy & Finance Intern",
    span: "2024",
    location: "Ahmedabad",
    summary:
      "Hands-on exposure to capital allocation, financial modelling, and project economics within an infrastructure business.",
    skills: ["Finance", "Modelling", "Strategic Analysis"],
    achievements: ["Supported project feasibility analysis", "Built operational dashboards"],
  },
  {
    id: "hastkesar",
    company: "Hastkesar Panjrapole",
    role: "Web Project Lead & Developer",
    span: "2025",
    location: "Gujarat",
    summary:
      "Designed and built the institution\u2019s digital presence \u2014 a responsive, accessible, donor-friendly website with content management. Live at bokadiaanandashray.com.",
    skills: ["Web Design", "Frontend Development", "UX", "Branding"],
    achievements: [
      "Shipped bokadiaanandashray.com \u2014 the first product launch",
      "Mobile-first responsive design",
      "Improved discoverability & donor engagement",
    ],
  },
];

export const CERTIFICATIONS = [
  { name: "IB Diploma Programme", issuer: "International Baccalaureate", year: "2023" },
  { name: "Diploma in Business (UTS Pathway)", issuer: "GLS International Studies", year: "In Progress" },
  { name: "Research Presentation", issuer: "Int. Conference on Applied Physics & Material Science", year: "2020" },
  { name: "Equestrian \u2014 National Participation", issuer: "Equestrian Federation of India", year: "2018" },
  { name: "Swimming \u2014 Inter-school Medals", issuer: "School & State Tournaments", year: "2017 \u2014 2020" },
];

export const AWARDS = [
  {
    id: "a1",
    title: "Pickleball & Junoon \u2014 Season 1",
    subtitle: "Tournament Winner",
    org: "Pickleball & Junoon \u00b7 Title Sponsor: BEVRA",
    year: "2025",
    date: "21 June 2025",
    category: "Sport",
    image: PHOTOS.pickleballTrophy,
    detail: "First-place finish at the inaugural Pickleball & Junoon Season 1 tournament. A reminder that the discipline of sport \u2014 quick hands, quicker decisions \u2014 never really leaves.",
    accent: "#e6c769",
  },
  {
    id: "a2",
    title: "JITO Racquet Cup",
    subtitle: "Badminton Participant",
    org: "JITO Apex Forum \u00b7 Goregaon Tank",
    year: "2024",
    date: "Gourmet Village, Goregaon",
    category: "Sport",
    image: PHOTOS.jitoRacquetCup,
    detail: "Competed at the JITO Racquet Cup \u2014 a community badminton event hosted by the JITO Apex Forum. A weekend of sport, fellowship, and friendly rivalry.",
    accent: "#fbbf24",
  },
  {
    id: "aSatyapur",
    title: "Satyapur Olympiad \u2014 Season 2",
    subtitle: "Athletics Medallist",
    org: "Satyapur Olympiad \u00b7 YCR Sports",
    year: "2024",
    date: "Track & Field",
    category: "Sport",
    image: PHOTOS.satyapurOlympiad,
    detail: "Medal podium finish at the Satyapur Olympiad Season 2 \u2014 a community athletics meet with national-style podium ceremonies and competitive heats.",
    accent: "#7dd3fc",
  },
  {
    id: "aOneWealth",
    title: "360 ONE Wealth \u2014 Industry Event",
    subtitle: "Featured Attendee",
    org: "360 ONE Wealth",
    year: "2025",
    date: "Industry Conclave",
    category: "Leadership",
    image: PHOTOS.oneWealth,
    detail: "Shared the stage with senior leaders from 360 ONE Wealth during an industry session on private wealth, portfolio strategy, and the future of family-office investing.",
    accent: "#86efac",
  },
  {
    id: "a3",
    title: "Diploma of Business \u2014 UTS College",
    subtitle: "University of Technology Sydney",
    org: "UTS College Limited \u00b7 Sydney, Australia",
    year: "2026",
    date: "Admitted 31 March 2026",
    category: "Academic",
    image: PHOTOS.utsDiploma,
    detail: "Formally admitted to the Diploma of Business at UTS College \u2014 the pathway programme into the University of Technology Sydney. A serious global credential anchoring my path into international business, finance, and entrepreneurship.",
    accent: "#e6c769",
  },
  {
    id: "a3b",
    title: "IB Diploma Programme",
    subtitle: "Full IB Diploma",
    org: "International Baccalaureate \u00b7 Ahmedabad International School",
    year: "2023",
    date: "Graduated 2023",
    category: "Academic",
    detail: "Completed the rigorous IB Diploma Programme \u2014 Business, Economics, Mathematics, Physics; Extended Essay & Theory of Knowledge.",
    accent: "#a5b4fc",
  },
  {
    id: "a4",
    title: "RAM 2024 \u2014 Research Paper Presented",
    subtitle: "Simulation Study of CTS Solar Cell Using SCAPS",
    org: "Bikaner Technical University \u00b7 Condensed Matter Research Society",
    year: "2024",
    date: "15\u201316 November 2024 \u00b7 Bikaner",
    category: "Research",
    image: PHOTOS.ramCertificate,
    detail: "Presented an original research paper \u2014 \u2018Simulation Study of CTS Solar Cell Using SCAPS\u2019 \u2014 at the Second International Conference on Recent Trends in Applied Physics & Material Science (RAM 2024). Paper ID I1-0002. A serious early credential in computational materials research.",
    accent: "#c4b5fd",
  },
  {
    id: "a5",
    title: "Equestrian \u2014 National Participation",
    subtitle: "Dressage & Show Jumping",
    org: "Equestrian Federation of India",
    year: "2018",
    date: "JIRS \u00b7 Bengaluru",
    category: "Sport",
    detail: "Competed at the national level in dressage and show jumping during boarding years \u2014 hours that taught unflinching focus and the philosophy of working with an animal twice your weight.",
    accent: "#d4af37",
  },
  {
    id: "a6",
    title: "Swimming \u2014 Inter-school Medals",
    subtitle: "Freestyle & Relay",
    org: "School & State Tournaments",
    year: "2017 \u2014 2020",
    date: "Multiple seasons",
    category: "Sport",
    detail: "Multiple inter-school medals across freestyle and relay events. Endurance and tempo control as taught by the pool, lap after lap.",
    accent: "#7dd3fc",
  },
  {
    id: "a7",
    title: "Young Indians · 360° Conclave",
    subtitle: "Delegate · Ahmedabad Chapter",
    org: "CII Young Indians (Yi)",
    year: "2025",
    date: "Ahmedabad",
    category: "Leadership",
    detail: "Participated in the Young Indians 360° Conclave — a flagship convening of next-generation business leaders, founders, and changemakers.",
    accent: "#86efac",
  },
];

export const CREDENTIALS = [
  {
    id: "c-ylp",
    title: "Young Leaders Program 2026",
    issuer: "36ONE Asset Management (Pty) Ltd",
    issued: "2026",
    category: "Capital",
    skills: ["Networking", "Family Wealth Management", "Investment Strategy"],
    detail:
      "A selective programme curated by 36ONE Asset Management — deep-dive sessions on family wealth, capital markets behaviour, and building relationships that compound over generations.",
    accent: "#e6c769",
  },
  {
    id: "c-atomx",
    title: "Atom-x · National Management Fest",
    issuer: "GLS University",
    issued: "2024",
    category: "Leadership",
    skills: ["Public Speaking", "Leadership"],
    detail:
      "Represented at GLS University's flagship national-level management fest — competing across speaking, strategy and business simulation rounds.",
    accent: "#86efac",
  },
  {
    id: "c-aiml",
    title: "Artificial Intelligence & Machine Learning Projects",
    issuer: "Great Learning",
    issued: "2024",
    category: "Frontier",
    skills: ["Artificial Intelligence (AI)", "Machine Learning"],
    detail:
      "Applied AI/ML programme covering supervised and unsupervised learning, real-world model design, and the workflows behind modern intelligent systems.",
    accent: "#f0abfc",
  },
  {
    id: "c-tax",
    title: "Fundamentals of Taxation",
    issuer: "Great Learning",
    issued: "2024",
    category: "Capital",
    skills: ["Taxation", "Compliance", "Planning"],
    detail:
      "Foundations of direct and indirect taxation — structure, compliance and planning principles that underpin every operating company and investment vehicle.",
    accent: "#e6c769",
  },
  {
    id: "c-uiux",
    title: "UI/UX for Beginners",
    issuer: "Great Learning",
    issued: "2024",
    category: "Build",
    skills: ["UI Design", "UX Principles", "Website Updating"],
    detail:
      "Core principles of user interface and user experience — usability, visual hierarchy, and user-centric thinking. Applied directly into the Hastkesar Panjrapole web project.",
    accent: "#e6c769",
  },
  {
    id: "c-trade",
    title: "Complete Trading Masterclass Programme",
    issuer: "Money Plant Trading Academy",
    issued: "Jul 2025",
    category: "Capital",
    skills: ["Futures Trading", "Trading Strategy", "Risk Management"],
    detail:
      "Certificate of Achievement — a hands-on masterclass in trading strategies, financial markets, and investment techniques with a professional approach.",
    accent: "#e6c769",
  },
  {
    id: "c-ram2024",
    title: "RAM 2024 · Recent Trends in Applied Physics & Material Science",
    issuer: "Bikaner Technical University · Condensed Matter Research Society",
    issued: "Nov 2024",
    credentialId: "I1-0002",
    category: "Research",
    certificate: PHOTOS.ramCertificate,
    skills: ["Research Skills", "Scientific Communication"],
    detail:
      "Participation and paper presentation at the Second International Conference (RAM 2024) — Paper ID I1-0002. An early credential in computational materials research.",
    accent: "#c4b5fd",
  },
  {
    id: "c-hmcsf",
    title: "HMCSF · Young Leadership Program",
    issuer: "Harvard University",
    issued: "Jul 2023",
    category: "Leadership",
    skills: ["Organizational Leadership", "Public Speaking", "Global Affairs"],
    detail:
      "Harvard Model Congress San Francisco — a leadership programme convening delegates from across the world to debate global policy, governance and the craft of diplomacy.",
    accent: "#a5b4fc",
  },
  {
    id: "c-ashoka",
    title: "Economics, Policy & Society",
    issuer: "Ashoka University · Young Scholars Programme",
    issued: "Jun 2024",
    category: "Academic",
    skills: ["Microeconomics", "Macroeconomics", "Policy Making"],
    detail:
      "Ashoka University's Young Scholars Programme — incentives, markets, growth, and the interdisciplinary craft of public decision-making.",
    accent: "#a5b4fc",
  },
  {
    id: "c-msoffice",
    title: "MS Office & Advanced Excel",
    issuer: "Krishna Computer Center",
    issued: "Apr 2023",
    category: "Build",
    skills: ["Microsoft 365", "Advanced Excel", "Modelling"],
    detail:
      "Certified in MS Office & Advanced Excel — formulas, pivot tables, data modelling and the spreadsheet workflows that quietly run every business.",
    accent: "#e6c769",
  },
  {
    id: "c-coursera-org",
    title: "Organic Marketing · Facebook Groups for Small Businesses",
    issuer: "Coursera",
    issued: "Oct 2024",
    category: "Build",
    skills: ["Organic Marketing", "Community Building"],
    detail:
      "Modern organic marketing playbook for small businesses — community building, content strategy, and growth without paid spend.",
    accent: "#e6c769",
  },
  {
    id: "c-coursera-risk",
    title: "Investment Risk Management",
    issuer: "Coursera",
    issued: "May 2024",
    category: "Capital",
    skills: ["Risk Management", "Portfolio Strategy"],
    detail:
      "Frameworks for measuring, managing and pricing risk across asset classes — the discipline behind every durable portfolio.",
    accent: "#e6c769",
  },
  {
    id: "c-coursera-ba",
    title: "Business Analysis & Process Management",
    issuer: "Coursera Project Network",
    issued: "May 2024",
    credentialId: "N7WQXT4ZTKBP",
    category: "Build",
    skills: ["Business Analysis", "Process Management"],
    detail:
      "Mapping how businesses really work — process design, stakeholder requirements, and translating strategy into operational systems.",
    accent: "#7dd3fc",
  },
];

export const PROJECTS = [
  {
    id: "p-energyhub",
    name: "Business Workflow Automation Hub",
    tagline: "A modern operations dashboard that automates day-to-day business workflows.",
    url: "https://energy-finance-hub.preview.emergentagent.com/login",
    displayUrl: "energy-finance-hub.preview.emergentagent.com",
    year: "2026",
    role: "Designer · Developer · Product Lead",
    mission:
      "A full-stack dashboard that removes friction from real business operations \u2014 authenticated access, structured data workflows, task orchestration and clean reporting, so teams spend less time in spreadsheets and more time on the work that matters.",
    impact: [
      "Automates repetitive business workflows end-to-end",
      "Role-based authentication with a secure login flow",
      "Clean, mobile-responsive dashboard UI",
      "Built as a scalable operations platform, not a demo",
    ],
    stack: ["React", "Tailwind CSS", "FastAPI", "MongoDB", "Auth & Roles"],
    preview:
      "https://image.thum.io/get/width/1440/crop/900/https://energy-finance-hub.preview.emergentagent.com/login",
    accent: "#7dd3fc",
  },
  {
    id: "p-hastkesar",
    name: "Hastkesar Panjrapole",
    tagline: "Animal hospital & sanctuary · Bokadia Family Trust",
    url: "https://www.bokadiaanandashray.com",
    displayUrl: "bokadiaanandashray.com",
    year: "2025",
    role: "Designer · Developer · Project Lead",
    mission:
      "Hastkesar Panjrapole is an animal hospital and home in Gujarat caring for over 1,300 cows, bulls, dogs, horses, camels, rabbits, and birds — run by the Bokadia Family. I designed and built the institution's first digital home: a responsive, donor-friendly platform that opens its gates to volunteers, visitors, and well-wishers across the world.",
    impact: [
      "Brought a 1,300-animal sanctuary online for the first time",
      "Mobile-first responsive design across every breakpoint",
      "Donor & volunteer flow — clear paths to contribute",
      "Improved discoverability and global reach",
    ],
    stack: ["React", "Tailwind CSS", "Framer Motion", "Responsive UI/UX"],
    preview:
      "https://image.thum.io/get/width/1440/crop/900/https://www.bokadiaanandashray.com/",
    accent: "#e6c769",
  },
];

export const SKILLS = [
  // Build
  { name: "Website Building", group: "Build", note: "Web Developer · Hastkeshar Panjrapole · shipped a full responsive site." },
  { name: "Website Updating · UI/UX", group: "Build", note: "UI/UX for Beginners course · interface and experience fundamentals." },
  { name: "Business Management", group: "Build", note: "Microsoft 365 — operations, workflows, productivity stack." },
  { name: "Business Analysis", group: "Build", note: "Business Analysis & Process Management — mapping how businesses really work." },

  // Capital
  { name: "Financial Markets", group: "Capital", note: "Young Leaders Program 2026 — market structures, instruments, behaviour." },
  { name: "Family Wealth Management", group: "Capital", note: "Young Leaders Program 2026 — generational portfolio design and risk." },
  { name: "Futures Trading", group: "Capital", note: "Complete Trading Masterclass Programme — Certificate of Achievement." },
  { name: "Accounting", group: "Capital", note: "University of Technology Sydney — the language of every business." },
  { name: "Taxation", group: "Capital", note: "Fundamentals of Taxation — structure, compliance, planning." },

  // Analyse
  { name: "Microeconomics", group: "Analyse", note: "Economics, Policy & Society — incentives, markets, and choice." },
  { name: "Macroeconomics", group: "Analyse", note: "Economics, Policy & Society — money, growth, and policy levers." },
  { name: "Policy Making", group: "Analyse", note: "Economics, Policy & Society — the craft of public decision-making." },
  { name: "Research Skills", group: "Analyse", note: "RAM 2024 — Second International Conference on Applied Physics & Material Science." },
  { name: "Business Data Analytics", group: "Analyse", note: "Business Data Analyst · Nimba Nature Cure & Holistic Healthcare Centre." },

  // Frontier
  { name: "Artificial Intelligence (AI)", group: "Frontier", note: "AI & Machine Learning project — applied AI in real workflows." },
  { name: "MS Office & Advanced Excel", group: "Frontier", note: "Microsoft 365 — advanced spreadsheet modelling and automation." },

  // People
  { name: "Networking", group: "People", note: "Young Leaders Program 2026 — building relationships that compound." },
  { name: "People Management", group: "People", note: "University of Technology Sydney — leading teams with empathy and clarity." },
  { name: "Customer Value", group: "People", note: "University of Technology Sydney — designing experiences customers love." },
  { name: "Time Management", group: "People", note: "Assistant · Oswal Energies Limited — high-output schedules in real ops." },
  { name: "Offline Marketing", group: "People", note: "Marketing Intern · Marvel Impex — on-the-ground campaign execution." },
  { name: "Organizational Leadership", group: "People", note: "HMCSF (Harvard Model Congress San Francisco) · Young Leadership Program." },
  { name: "Public Speaking", group: "People", note: "Jain International Residential School · Atom-x National Management Fest." },
];

export const PLACES = [
  { id: "p1", name: "Ahmedabad", country: "India", phase: "Senior KG → Grade 10", year: "2010 — 2019", role: "The Foundation", note: "Where it all began — Senior KG through senior school. The years that built the curiosity, discipline, and habits I still live by.", lat: 23.03, lng: 72.58 },
  { id: "p2", name: "Bengaluru", country: "India", phase: "Jain International Residential School", year: "2017 — 2019", role: "Boarding & Sport", note: "An important boarding chapter — discipline forged at dawn through horsemanship, swimming, and the rigour of a residential school in a city of innovation.", lat: 12.97, lng: 77.59 },
  { id: "p3", name: "Gandhinagar", country: "India", phase: "Internships", year: "2022 — 2024", role: "Industry Exposure", note: "Hands-on internships across operations, infrastructure, and strategy. First taste of how real companies actually breathe.", lat: 23.22, lng: 72.65 },
  { id: "p4", name: "Ahmedabad · GLS", country: "India", phase: "GLS · College", year: "2024 — Present", role: "College & Leadership", note: "College years at GLS — Diploma in Business (UTS Sydney pathway). Entrepreneurship, finance, and active participation in leadership and student life.", lat: 23.06, lng: 72.55 },
  { id: "p5", name: "Sonipat", country: "India · Delhi NCR", phase: "Ashoka University", year: "2024", role: "Economics & Policy", note: "Ashoka University introduced me to economics, public policy, policymaking, critical thinking, and the interdisciplinary lens needed to understand governance and society.", lat: 28.99, lng: 77.02 },
  { id: "p6", name: "Mumbai", country: "India", phase: "Industry & Networks", year: "2024 — 2025", role: "The Markets", note: "India's financial heart. Industry exposure, professional networking, and learning from one of the world's most dynamic business ecosystems.", lat: 19.08, lng: 72.88 },
  { id: "p7", name: "Jaipur · Rajasthan", country: "India", phase: "Education & Culture", year: "2024", role: "Growth Beyond Class", note: "Educational experiences, cultural exploration, leadership development — and the kind of personal growth that happens far from a classroom.", lat: 26.91, lng: 75.79 },
  { id: "p8", name: "Siem Reap", country: "Cambodia", phase: "Global Service", year: "2024", role: "Volunteer · Teach · Rebuild", note: "One of the most meaningful chapters — volunteering to teach students, mentor children, and help rebuild their school. A study in social impact, empathy, and global citizenship.", lat: 13.36, lng: 103.86 },
];

export const VALUES = [
  { name: "Innovation", icon: "sparkles" },
  { name: "Integrity", icon: "shield" },
  { name: "Discipline", icon: "gauge" },
  { name: "Leadership", icon: "crown" },
  { name: "Curiosity", icon: "telescope" },
  { name: "Long-Term Thinking", icon: "infinity" },
  { name: "Execution", icon: "target" },
  { name: "Continuous Learning", icon: "book" },
];

export const VISION = [
  { phase: "01", title: "Operate", body: "Build and run companies. Learn the texture of operating excellence." },
  { phase: "02", title: "Allocate", body: "Found an investment firm. Public markets, private equity, ventures." },
  { phase: "03", title: "Compound", body: "Establish a family office. Generational portfolios. Patient capital." },
  { phase: "04", title: "Invent", body: "Back and build in AI \u2014 the most consequential technology of our era." },
  { phase: "05", title: "Legacy", body: "Capital allocated intelligently. People mentored generously. A lasting institution." },
];
